import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HideToolbarService {
  private hideToolbarFormSubject = new Subject<boolean>();
  private hideToolbarForm!: boolean;
  private hideToolbarFromFormMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  // devuelve datos email y num requerimiento
  setHideToolbarForm(change: boolean) {
    this.hideToolbarFormSubject.next(change);
    this.hideToolbarForm = change;
  }

  getHideToolbarForm() {
    return this.hideToolbarForm;
  }

  getHideToolbarFormObservable() {
    return this.hideToolbarFormSubject.asObservable();
  }

  set hideToolbarFromFormModeSet(value: boolean) {
    this.hideToolbarFromFormMode.next(value);
  }

  get hideToolbarFromFormMode$() {
    return this.hideToolbarFromFormMode.asObservable();
  }
}


